import {
  APIContextOptions,
  createAPIContext,
  createBloodSampleAPI,
  createBookingAPIv2,
  createCheckInQuestionsAPI,
  createConsentAPIv1,
  createConsentAPIv2,
  createEcgAPI,
  createMeasurementsAPI,
  createNekoScopeAPI,
  createPatientAPI,
  createQuestionnaireAPI,
  createRiskRangeAPI,
  createRoomAPI,
  createScanAPI,
  createScheduleAPI,
  createSiteAPI,
  createSiteCheckinSessionAPI,
  createUserAPI,
  createVisitAPI,
} from "@cur8/api-client";
import { createBloodSampleDrawAPI } from "lib/api/bloodSampleDraw";
import { createTimelineAPI } from "lib/api/timeline";

export function createClient(options: APIContextOptions) {
  const context = createAPIContext(options);

  return {
    ecg: createEcgAPI(context),
    bloodSample: {
      ...createBloodSampleAPI(context),
      ...createBloodSampleDrawAPI(context),
    },
    booking: createBookingAPIv2(context),
    consent: createConsentAPIv1(context),
    consentV2: createConsentAPIv2(context),
    patient: createPatientAPI(context),
    scan: createScanAPI(context),
    schedule: createScheduleAPI(context),
    site: createSiteAPI(context),
    siteCheckinSession: createSiteCheckinSessionAPI(context),
    user: createUserAPI(context),
    visit: createVisitAPI(context),
    questionnaire: createQuestionnaireAPI(context),
    checkInQuestions: createCheckInQuestionsAPI(context),
    measurement: createMeasurementsAPI(context),
    riskRange: createRiskRangeAPI(context),
    room: createRoomAPI(context),
    nekoScope: createNekoScopeAPI(context),
    timeline: createTimelineAPI(context),
  };
}

export type APIClient = ReturnType<typeof createClient>;
